/**
 * Giveaway bundle — site-wide free-gift sync.
 *
 * Keeps the 2 free-gift lines ("_giveaway_gift" property) in sync with any
 * gated product, from anywhere on the site (PDP, collection quick-add,
 * search, "you may also like", etc.) — not just the PDP's own buy box:
 *
 * - If a gated product is in the cart but the gifts aren't, adds them.
 *   Requires window.__pvGiveawayConfig (rendered inline in
 *   layout/theme.liquid from the "Giveaway Bundle" theme settings) with
 *   productIds (array — supports multiple products sharing the same
 *   promo), ebookVariantId, entryVariantId.
 * - If no gated product is in the cart ("_giveaway_main" property, set in
 *   pv-product-section.js, is also checked as a fallback), removes any
 *   orphaned gifts.
 *
 * Loaded globally (layout/theme.liquid), not from pv-product-section.js,
 * so both checks run on every page.
 */
(function () {
  'use strict';

  function dispatchCartRefresh(cart) {
    try {
      var ev = new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } });
      document.documentElement.dispatchEvent(ev);
    } catch (e) { /* noop */ }
  }

  function hasGatedProduct(cart) {
    var config = window.__pvGiveawayConfig;
    var gatedIds = (config && config.productIds) || [];
    return cart.items.some(function (item) {
      if (item.properties && item.properties['_giveaway_main']) return true;
      return gatedIds.some(function (id) { return String(item.product_id) === String(id); });
    });
  }

  function removeOrphanedGifts(cart) {
    var giftLines = cart.items.filter(function (item) {
      return item.properties && item.properties['_giveaway_gift'];
    });
    if (giftLines.length === 0) return Promise.resolve(null);

    // /cart/change.js only changes ONE line per request (it does not accept
    // a bulk "updates" map — that's /cart/update.js). Remove each gift line
    // individually, one after another, so a failure on one doesn't affect
    // the other.
    var lastBody = null;
    return giftLines.reduce(function (chain, item) {
      return chain.then(function () {
        return fetch('/cart/change.js?sections=mini-cart', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0, sections: 'mini-cart' })
        }).then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) {
              console.error('[PV Giveaway Sync] failed to remove orphaned gift', item.key, body);
            } else {
              lastBody = body;
            }
            return body;
          });
        });
      });
    }, Promise.resolve()).then(function () {
      return lastBody;
    });
  }

  function addMissingGifts(cart) {
    var config = window.__pvGiveawayConfig;
    if (!config) return Promise.resolve(null);

    var existingGiftKeys = {};
    cart.items.forEach(function (item) {
      var giftKey = item.properties && item.properties['_giveaway_gift'];
      if (giftKey) existingGiftKeys[giftKey] = true;
    });

    var items = [];
    if (config.ebookVariantId && !existingGiftKeys.ebook) {
      items.push({
        id: config.ebookVariantId,
        quantity: 1,
        properties: { '_giveaway_gift': 'ebook', 'Gift': 'Free E-book' }
      });
    }
    if (config.entryVariantId && !existingGiftKeys.entry) {
      items.push({
        id: config.entryVariantId,
        quantity: 1,
        properties: { '_giveaway_gift': 'entry', 'Gift': 'Garmin Venu 4 Giveaway Entry' }
      });
    }
    if (items.length === 0) return Promise.resolve(null);

    return fetch('/cart/add.js?sections=mini-cart', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'mini-cart' })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) {
          console.error('[PV Giveaway Sync] failed to add missing gifts', body);
          return null;
        }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (freshCart) {
            if (body.sections) freshCart.sections = body.sections;
            return freshCart;
          })
          .catch(function () { return body; });
      });
    });
  }

  function syncGiveawayCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return hasGatedProduct(cart) ? addMissingGifts(cart) : removeOrphanedGifts(cart);
      })
      .then(function (changedBody) {
        if (changedBody) dispatchCartRefresh(changedBody);
      })
      .catch(function (err) {
        console.error('[PV Giveaway Sync] error', err);
      });
  }

  syncGiveawayCart();
  document.addEventListener('cart:refresh', function () {
    syncGiveawayCart();
  });
})();
